export enum Environments {
    CODE_PARAMETER_MAIL = 'MAIL',
    CODE_PARAMETER_HOST_EMAIL = 'HOST_MAIL',
    CODE_PARAMETER_PORT_EMAIL = 'PORT_MAIL',
    CODE_PARAMETER_USER_EMAIL = 'USER_MAIL',
    CODE_PARAMETER_PASS_EMAIL = 'PASSWORD_MAIL',
    CODE_PARAMETER_EMISOR_EMAIL = 'EMISOR_MAIL',
    PARAMETER_EMAIL_LOGO = 'MAIL_LOGO',
    LIMIT = 15,
    PAGE = 1,
    TIMEZONE_HOURS = 0,
    TIMEZONE_HOURS_MONGO = 0,
  }
  